package uz.ferro.erp.feature.task.model.dto

import kotlinx.serialization.Serializable
import uz.ferro.erp.feature.address.model.GeoAddressDto
import uz.ferro.erp.feature.customer.model.CustomerDto
import uz.ferro.erp.feature.task.model.TargetType
import uz.ferro.erp.feature.task.model.TaskStatus
import uz.ferro.erp.feature.user.model.UserDto

@Serializable
data class TaskDto(
    val id: Long?,
    val uuid: String?,
    val typeId: String,
    val typeName: String,
    val status: TaskStatus?,
    val description: String?,
    val assignedTo: UserDto?,
    val assignedBy: UserDto?,
    val customer: CustomerDto?,
    val address: GeoAddressDto?,
    val date: String?,
    val createdDate: String?,
    val targetType: TargetType?,
    val targetId: Long?,
    val targetDocNum: Long?,
    val resultTypeId: String?,
    val resultTypeName: String?,
    val resultDate: String?,
    val resultComment: String?,
    val delayedDate: String?
)